







































































































import {
    Component, Vue, Prop, Watch, Model,
} from 'vue-property-decorator';
import CustomDialog from '@/components/global/CustomDialog.vue';
import SimpleDialog from '@/components/global/SimpleDialog.vue';
import Tabs from '@/components/global/Tabs.vue';
import InsertCsvDialogUpload from '@/components/global/InsertCsvDialog/InsertCsvDialogUpload.vue';
import InsertCsvDialogOpen from '@/components/global/InsertCsvDialog/InsertCsvDialogOpen.vue';
import index from '@/store';
import { merge } from 'lodash';
import { ProductTemplate } from '@/assets/interface/Product';
import { RENAME_TEMPLATE, DELETE_TEMPLATE } from '@/store/modules/template';
import { CSVFile, ADD_CSV_FILE } from '@/store/modules/csv';

@Component({
    components: {
        CustomDialog,
        SimpleDialog,
        Tabs,
        InsertCsvDialogUpload,
        InsertCsvDialogOpen,
    },
})
export default class InsertCsvDialog extends Vue {
    @Model('update:InsertCSVDialogValue', { type: Boolean }) readonly value!: boolean;

    public infoDialog = false;
    // info dialog properties
    public infoDialogProperties = {
        contentHeight: '90px',
        showNegativeButton: false,
        positiveLabel: 'Ok',
        title: '',
        message: '',
    }

    public tab: any = null;

    public tabItems = [
        {
            name: 'Open',
        },
        {
            name: 'Upload',
        },
        // {
        //     name: 'Web Address (URL)',
        // },
    ];

    public activeItem: CSVFile | null = null;

    public updateInfoDialogProperties(properties: any) {
        this.infoDialog = true;
        this.infoDialogProperties = merge(this.infoDialogProperties, properties);
    }

    public async onUploadFinish(file: CSVFile) {
        await this.$store.dispatch(ADD_CSV_FILE, file);
        this.$emit('insert', file);
        this.closeDialog();
    }

    public emitReturnValue(event: any) {
        this.$emit('update:InsertCSVDialogValue', event);
    }

    public onInsertClick() {
        this.$emit('insert', this.activeItem);
        this.closeDialog();
    }

    public onOpen(file: CSVFile) {
        this.$emit('insert', file);
        this.closeDialog();
    }

    public onCancelClick() {
        this.closeDialog();
    }

    public closeDialog() {
        this.emitReturnValue(false);
    }

    get csvFiles(): CSVFile[] {
        return this.$store.getters.getCSVs;
    }

    get insertButtonDisabled() {
        switch (this.tab) {
                case 0:
                // open
                    return !this.activeItem;
                default:
                    return true;
        }
    }
}
